import React, { HTMLAttributes } from 'react'
import { ProductCard } from '../ProductCard'
import { StylesVariants, styles } from './BannerCards.css'
import { AppList } from "@otomoro/components/shared/AppList"
import { SectionHeader } from "@otomoro/components/shared/SectionHeader"
import { Tag } from '@otomoro/components/shared/Tag'
import { PortableText, PortableTextComponents } from 'next-sanity'
import { AppTitle } from '@otomoro/components/shared/AppTitle'

interface ProductsProps extends HTMLAttributes<Element>, StylesVariants {
	productsList: Array<any>
	headline: any
	tag: string
}

export const BannerCards: React.FC<ProductsProps> = ({ tag, headline, productsList }) => {
	const { wrapper, base, list } = styles()

	const components = {
		block: {
			normal: ({ children }: any) => (
				<AppTitle as="h2" textTransform="uppercase" className="mt-1" color="white">
					{children}
				</AppTitle>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<div className={wrapper()}>
			<aside className={base()}>
				<header className='lg:shrink-0 lg:mr-4'>
					<Tag as="strong" className="" theme="dark">{tag}</Tag>
					<PortableText value={headline} components={components} />
				</header>
				<AppList className={list()}>
					{productsList.map((product) => (
						<ProductCard
							key={product._id}
							formula={product.formula}
							productName={product.title}
							productLogo={product.productLogo}
							slug={product.slug}
							type={product._type}
						/>
					))}
				</AppList>
			</aside>
		</div>
	)
}
